package com.vizio.pay.api

import com.vizio.redwolf.pay.api.ProductsApi
import com.vizio.redwolf.pay.api.ProductsResult
import com.vizio.redwolf.utils.AppConfig
import com.vizio.redwolf.utils.PayEnvironment
import com.vizio.redwolf.utils.ResponseHeaders
import com.vizio.redwolf.utils.clientprovider.WebApiUseCase
import kotlin.js.Promise

@JsExport
class ProductsJsApi(productsEnv: PayEnvironment, jsClientConfig: JsClientConfig? = null) {
    private val productsApi = ProductsApi(payEnv = productsEnv,
                                          appConfig = AppConfig(""),
                                          clientConfig = jsClientConfig.toClientConfig(WebApiUseCase.COOKIE_SDK_HEADERS)
    )

    @JsName("getProducts")
    fun getProducts(jsProductIds: dynamic): Promise<dynamic> {
        return handleJsPromiseRequest(exceptionHandler = ::handleProductsJsException) {
            val productIds = (jsProductIds as Array<String>).asList()
            productsApi.getProducts(productIds)
        }
    }

    @JsName("getCategories")
    fun getCategories(): Promise<dynamic> {
        return handleJsPromiseRequest(exceptionHandler = ::handleProductsJsException) {
            productsApi.getCategories()
        }
    }

    @JsName("getProductsByCategory")
    fun getProductsByCategory(categoryId: String): Promise<dynamic> {
        return handleJsPromiseRequest(exceptionHandler = ::handleProductsJsException) {
            productsApi.getProductsByCategory(categoryId)
        }
    }

    @JsName("getProductTypes")
    fun getProductTypes(): Promise<dynamic> {
        return handleJsPromiseRequest(exceptionHandler = ::handleProductsJsException) {
            productsApi.getProductTypes()
        }
    }

    @JsName("getCategoryDetails")
    fun getCategoryDetails(categoryId: String): Promise<dynamic> {
        return handleJsPromiseRequest(exceptionHandler = ::handleProductsJsException) {
            productsApi.getCategoryDetails(categoryId)
        }
    }

    @JsName("getProductById")
    fun  getProductById(id: String): Promise<dynamic> {
        return handleJsPromiseRequest(exceptionHandler = ::handleProductsJsException) {
            productsApi.getProductById(id)
        }
    }

    private fun <T: Any> handleProductsJsException(ex: Exception, data: JsExceptionInfo<T>? = null): ProductsResult.Error {
        return ProductsResult.Error(ResponseHeaders.Invalid, Exception(jsRequestExceptionError))
    }
}